import { useMemo } from 'react';
import Hero from './components/Hero';
import HomeProgressStrip from './components/HomeProgressStrip';
import LearningPath from './components/LearningPath';
import BasicsGrid from './components/BasicsGrid';
import TradingSteps from './components/TradingSteps';
import PlatformSection from './components/PlatformSection';
import AnalysisSection from './components/AnalysisSection';
import RiskSection from './components/RiskSection';
import BrokerTeaser from './components/BrokerTeaser';
import FaqSection from './components/FaqSection';
import { faqPageSchema, useSeo } from '@/hooks/useSeo';
import { faqItems } from '@/mocks/home';

export default function Home() {
  // Organization / WebSite 结构化数据已在 index.html 静态输出，这里仅补充页面级 FAQ
  const jsonLd = useMemo(() => [faqPageSchema(faqItems)], []);

  useSeo({
    /* @replace:home-title */
    title: 'เรียน Forex พื้นฐานสำหรับมือใหม่ | คู่มือเทรด Forex, MT4/MT5 และบริหารความเสี่ยง',
    description:
      /* @replace:home-description */
      'คู่มือเรียน Forex สำหรับมือใหม่ ตั้งแต่ Forex คืออะไร คู่เงิน Pip Spread Leverage ไปจนถึงวิธีเทรด Forex การใช้ MT4/MT5 การวิเคราะห์กราฟ และการบริหารความเสี่ยง',
    /* @replace:home-keywords */
    keywords: 'เรียน Forex, Forex พื้นฐาน, วิธีเทรด Forex, MT4, MT5, Pip, Spread, Leverage, บริหารความเสี่ยง',
    canonicalPath: '/',
    jsonLd,
  });

  return (
    <>
      <Hero />
      <HomeProgressStrip />
      <LearningPath />
      <BasicsGrid />
      <TradingSteps />
      <PlatformSection />
      <AnalysisSection />
      <RiskSection />
      <BrokerTeaser />
      <FaqSection />
    </>
  );
}